<div class="{{ paddingClasses }} input__form"
  [ngClass]="(formGroup ? (formGroup.get(name)?.valid && !formGroup.get(name)?.touched ? 'valid':'invalid' ):null)">
  @if (label != '') {
    <label class="{{ paddingClasses }} so-text-3" [style]="labelStyle">{{label}}<app-so-required-mark
      [show]="requiredMark" /></label>
  }
  @if (formGroup) {
    <textarea [formControlName]="formGroup ?name:null" class="form-control" [rows]="rows" [attr.id]="inputId"
      [placeholder]="placeholder" [value]="text" [disabled]="disabled" [style]="areaStyles"
      [attr.maxlength]="maxlength ? maxlength : null" [maxLength]="maxlength" (input)="updateValue(getValue($event))"
      [SanitizeInput]="applySanitize" name="{{name}}" #textarea (click)="onCursorPositionChange()" (keyup)="onCursorPositionChange()"
      (keydown)="onKeyDown($event)" (paste)="onPaste($event)" (keypress)="onKeyPress($event)">
      {{text}}
    </textarea>
  }@else{
    @if(formControl){
      <textarea class="form-control" [rows]="rows" [attr.id]="inputId"
        [placeholder]="placeholder" [value]="text" [style]="areaStyles"
        [attr.maxlength]="maxlength ? maxlength : null" [maxLength]="maxlength" (input)="updateValue(getValue($event))"
        [SanitizeInput]="applySanitize" name="{{name}}" #textarea (click)="onCursorPositionChange()" (keyup)="onCursorPositionChange()"
        (keydown)="onKeyDown($event)" (paste)="onPaste($event)" (keypress)="onKeyPress($event)" [formControl]="formControl">
        {{text}}
      </textarea>
      @if(formControl.invalid && formControl.touched && formControl.errors) {
        @if (formControl.errors['forbiddenChars'] || formControl.errors['forbiddenEmojis'] || formControl.errors['invalidVariables']?.length || formControl.errors['unclosedBracket'] || formControl.errors['unopenedBracket']) {
          <span class="input__form-message">
            <label class="invalid">
                @if (formControl.errors['forbiddenChars']) {
                      {{ 'chars_invalid' | translated : 'El texto contiene caracteres no permitidos:' }}
                      {{ formControl.errors['forbiddenChars'].join(' ') }}.
                }
                @if (formControl.errors['forbiddenEmojis']) {
                      No se permiten estos emojis:
                      {{ formControl.errors['forbiddenEmojis'].join(' ') }}.
                }
                @if (formControl.errors['invalidVariables']?.length) {
                      {{ 'prompting_invalid_variables' | translated : 'Variables inválidas. Usa el catálogo de variables del sistema:' }}
                      {{ formControl.errors['invalidVariables'].join(', ') }}.
                }
                @if (formControl.errors['unclosedBracket']) {
                      {{ 'prompting_unclosed_bracket' | translated : 'Bracket "[" sin cerrar.' }}
                }
                @if (formControl.errors['unopenedBracket']) {
                      {{ 'prompting_unopened_bracket' | translated : 'Bracket "]" sin abrir.' }}
                }
              </label>
            </span>
        }
      }
    }@else{
      <textarea class="form-control" [rows]="rows" [attr.id]="inputId"
        [placeholder]="placeholder" [value]="text" [disabled]="disabled" [style]="areaStyles"
        [attr.maxlength]="maxlength ? maxlength : null" [maxLength]="maxlength" (input)="updateValue(getValue($event))"
        [SanitizeInput]="applySanitize" name="{{name}}" #textarea (click)="onCursorPositionChange()" (keyup)="onCursorPositionChange()"
        (keydown)="onKeyDown($event)" (paste)="onPaste($event)" (keypress)="onKeyPress($event)">
        {{text}}
      </textarea>
    }
  }
</div>
